import { noConflictInterestedToViewApi, noConflictNotInterestedToViewApi, raiseNotificationApi, reportCaseApi } from 'Constants';
import { Context } from 'Context/Context';
import ReportModal from 'Modals/ReportModal';
import { getCaseType } from 'Utils';
import React, { useContext, useState } from 'react'
import { toast } from 'react-toastify';

function IconsOnListView({detail, onMainModalClose = () => {}, 
setRefreshList = () => {}, setCloseMsg = () => {},
setUpdateComp, attorney = null, updateCaseResponse = () => {}, inDetailsPage = false}) {
    
  const [onHoverThumb, setOnHoverThumb] = useState(false);
  const [onHoverReport, setOnHoverReport] = useState(false);
  const [showReportDropDown, setShowReportDropDown] = useState(false);
  const [showReportConfirmModal, setShowReportConfirmModal] = useState(false);
  const [reason, setReason] = useState("");
  const { makeApiCallFunc, userDetails} = useContext(Context);
  const userInfoObj = attorney !== null ? attorney?.userId : detail?.userId ? detail?.userId : userDetails;
  const userInfo = attorney !== null ? attorney?.userId?._id : detail?.userId ? detail?.userId : userDetails?._id;
 
  const reportCase = (e) => {
    e.stopPropagation();
    makeApiCallFunc(reportCaseApi, {
      caseId: detail._id,
      userId: userInfo,
      reason: reason
  },
              
              (data) => 
              {
                 // onMainModalClose();
                  e.stopPropagation();
                  toast.info(detail?.caseNumber  + " reported successfully and removed from your cases list.");
                   const userType = userInfoObj?.isUserFunder ? "Litigation funder" : "Attorney";
                                 //test
                    const notificationObj = {
                        title : userType + " removed from case " + getCaseType(detail?.caseType) + " " + detail?.caseNumber,
                        is_read : false,
                        sender: "professional",
                        notificationCategory: 1,
                        caseNumber: detail?.caseNumber,
                        type: "4",
                        receiver:  detail?.owner,
                        additionalInfo : {
                            "caseId": detail?._id,
                            "userId": userInfoObj._id
                        },
                        content: "Unfortunately, the "+userType+" "+userInfoObj?.firstName+" "+userInfoObj.lastName+" is no longer interested in this case. You may continue to seek other "+userType+"s available for your case."
                    }
                    makeApiCallFunc(raiseNotificationApi,
                        notificationObj,
                          (data) => 
                            {
                              console.log("report case");
                                onMainModalClose();
                               setShowReportConfirmModal(false);
                              setUpdateComp(prev => !prev);
                            },
                          (error) => console.log(error)
                          );
                 
              },
  (data) => console.log(data)
  )
  }
  const interested = (e) => {
        makeApiCallFunc(
            noConflictInterestedToViewApi,
            {
              caseId: detail?._id,
              userId: userInfo,
              assistantId: detail?.assistantId?.[0]?._id,
              type: detail?.caseStatus
            },
            (data) => {
                console.log(data);
                // toast.success("Client has been notified.");
                  toast.info(detail?.caseNumber + " moved to my cases list.");
                    const notificationObj = {
                        title : "Professional "+userDetails?.firstName+" "+userDetails?.lastName+" has availability to view your case" + getCaseType(detail?.caseType) + " - " + detail?.caseNumber,
                        is_read : false,
                        sender: "professional",
                        type: "3",
                    notificationCategory: 1,
                    receiver:  detail?.owner,
                        additionalInfo : {
                            "caseId": detail?._id,
                            "userId": userDetails._id
                        },
                        content: "A verified Legal Professional "+ userDetails?.firstName +" "+ userDetails?.lastName +" has marked your case as interested on your "+getCaseType(detail?.caseType),
                        }
                makeApiCallFunc(raiseNotificationApi, 
                            notificationObj, 
                             (data) => console.log(data),
                             (error) => console.log(error)
                            )
                            if(inDetailsPage)
                            {
                               setRefreshList(true);
                              setCloseMsg(detail?.caseNumber + " moved to My cases list.");
                              updateCaseResponse(detail?._id)

                            }
                            else
                            {
                              setUpdateComp(prev => !prev);
                            }

            },
            (data) => {
                console.log(data)},
        )
        e.stopPropagation();
}
  const notInterested = (e) => {
          makeApiCallFunc(
              noConflictNotInterestedToViewApi,
              {
                  caseId: detail?._id,
                  userId: userInfo,
                  assistantId: detail?.assistantId?.[0]?._id,
                  type: detail?.caseStatus
              },
              (data) => {
                  //setIsInterested((prev) => !prev);
                  console.log(data);
                  toast.info(detail?.caseNumber + " moved to not interested cases list.");
                  

                  // toast.success("Client has been notified.");
                      const notificationObj = {
                          title : "Legal Attorney "+userDetails?.firstName+" "+userDetails?.lastName+" who cleared conflict has marked your case " + getCaseType(detail?.caseType) + " - " + detail?.caseNumber + " as not interested",
                          is_read : false,
                          sender: "professional",
                    notificationCategory: 1,
                    type: "3",
                          receiver:  detail?.owner,
                          additionalInfo : {
                              "caseId": detail?._id,
                              "userId": userDetails._id
                          },
                          content: "A verified Legal Attorney "+ userDetails?.firstName +" "+ userDetails?.lastName +" has marked your case " + getCaseType(detail?.caseType) + " - " + detail?.caseNumber + " as not interested on your "+getCaseType(detail?.caseType)+ ". We will continue to notify you with more attorneys as and when they show interest",
                          }
                          makeApiCallFunc(raiseNotificationApi, 
                              notificationObj, 
                               (data) => console.log(data),
                               (error) => console.log(error)
                              )
                              if(inDetailsPage)
                              {
                                  setRefreshList(true);
                                  setCloseMsg(detail?.caseNumber + " moved to not interested cases list.");
                                  updateCaseResponse(detail?._id)

                              }
                              else
                              {
                                setUpdateComp(prev => !prev);
                              }

              },
              (data) => console.log(data),
          )
          e.stopPropagation();
  }
  return (
    <>
    {
      showReportConfirmModal &&
      <ReportModal
      uploadNew={showReportConfirmModal}
      onSubmit={reportCase}
      onClose={() => setShowReportConfirmModal(false)}
      />
  }
    <div className='flex items-center'>
    {detail?.caseInterest ? 
    <div className='relative text-xs' onMouseEnter={() => setOnHoverThumb(true)}
    onClick={(e) => interested(e)}
    onMouseLeave={() => setOnHoverThumb(false)}>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-6 h-6 ">
     <path d="M15.73 5.5h1.035A7.465 7.465 0 0 1 18 9.625a7.465 7.465 0 0 1-1.235 4.125h-.148c-.806 0-1.534.446-2.031 1.08a9.04 9.04 0 0 1-2.861 2.4c-.723.384-1.35.956-1.653 1.715a4.499 4.499 0 0 0-.322 1.672v.633A.75.75 0 0 1 9 22a2.25 2.25 0 0 1-2.25-2.25c0-1.152.26-2.243.723-3.218.266-.558-.107-1.282-.725-1.282H3.622c-1.026 0-1.945-.694-2.054-1.715A12.137 12.137 0 0 1 1.5 12.25c0-2.848.992-5.464 2.649-7.521C4.537 4.247 5.136 4 5.754 4H9.77a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23ZM21.669 14.023c.536-1.362.831-2.845.831-4.398 0-1.22-.182-2.398-.52-3.507-.26-.85-1.084-1.368-1.973-1.368H19.1c-.445 0-.72.498-.523.898.591 1.2.924 2.55.924 3.977a8.958 8.958 0 0 1-1.302 4.666c-.245.403.028.959.5.959h1.053c.832 0 1.612-.453 1.918-1.227Z" />
     </svg>
     {onHoverThumb && 
            <>
            <div className='absolute  shadow-md border text-gray-900 bg-yellow-100 w-max rounded font-medium border border-yellow-200 top-8 right-0 p-2'>
                <div>Mark this as interested     </div>
                <div className="border-[10px] border-t-0 border-t-transparent border-l-transparent border-r-transparent border-b-yellow-100 h-0 w-0 absolute -top-2 right-0"></div> 
              </div></>}
     </div>
    :
    <div className='relative text-xs' onMouseEnter={() => setOnHoverThumb(true)}
    onClick={(e) => notInterested(e)}
    onMouseLeave={() => setOnHoverThumb(false)}> 
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-6 h-6">
    <path stroke-linecap="round" stroke-linejoin="round" d="M7.498 15.25H4.372c-1.026 0-1.945-.694-2.054-1.715a12.137 12.137 0 0 1-.068-1.285c0-2.848.992-5.464 2.649-7.521C5.287 4.247 5.886 4 6.504 4h4.016a4.5 4.5 0 0 1 1.423.23l3.114 1.04a4.5 4.5 0 0 0 1.423.23h1.294M7.498 15.25c.618 0 .991.724.725 1.282A7.471 7.471 0 0 0 7.5 19.75 2.25 2.25 0 0 0 9.75 22a.75.75 0 0 0 .75-.75v-.633c0-.573.11-1.14.322-1.672.304-.76.93-1.33 1.653-1.715a9.04 9.04 0 0 0 2.86-2.4c.498-.634 1.226-1.08 2.032-1.08h.384m-10.253 1.5H9.7m8.075-9.75c.01.05.027.1.05.148.593 1.2.925 2.55.925 3.977 0 1.487-.36 2.89-.999 4.125m.023-8.25c-.076-.365.183-.75.575-.75h.908c.889 0 1.713.518 1.972 1.368.339 1.11.521 2.287.521 3.507 0 1.553-.295 3.036-.831 4.398-.306.774-1.086 1.227-1.918 1.227h-1.053c-.472 0-.745-.556-.5-.96a8.95 8.95 0 0 0 .303-.54" />
    </svg>
    {onHoverThumb && 
            <>
            <div className='absolute shadow-md border text-gray-900 bg-yellow-100 w-max rounded font-medium border border-yellow-200 top-8 right-0 p-2'>
                <div>Mark this as not interested     </div>
                <div className="border-[10px] border-t-0 border-t-transparent border-l-transparent border-r-transparent border-b-yellow-100 h-0 w-0 absolute -top-2 right-0"></div> 
              </div></>}
    </div>
    }
   
    <div 
     className='relative text-xs'
    onMouseEnter={() => setOnHoverReport(true)}
    onMouseLeave={() => setOnHoverReport(false)}
    onClick={(e)=>{setOnHoverReport(false);
      setShowReportDropDown(prev => !prev);
      e.stopPropagation();
    }}
    >
      {showReportDropDown 
      ?
      <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" class="w-[20px] h-[20px] ml-1">
        <path fill-rule="evenodd" d="M3 2.25a.75.75 0 0 1 .75.75v.54l1.838-.46a9.75 9.75 0 0 1 6.725.738l.108.054A8.25 8.25 0 0 0 18 4.524l3.11-.732a.75.75 0 0 1 .917.81 47.784 47.784 0 0 0 .005 10.337.75.75 0 0 1-.574.812l-3.114.733a9.75 9.75 0 0 1-6.594-.77l-.108-.054a8.25 8.25 0 0 0-5.69-.625l-2.202.55V21a.75.75 0 0 1-1.5 0V3A.75.75 0 0 1 3 2.25Z" clip-rule="evenodd" />
      </svg>
 
      :
    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor" class="w-[20px] h-[20px] ml-1">
    <path stroke-linecap="round" stroke-linejoin="round" d="M3 3v1.5M3 21v-6m0 0 2.77-.693a9 9 0 0 1 6.208.682l.108.054a9 9 0 0 0 6.086.71l3.114-.732a48.524 48.524 0 0 1-.005-10.499l-3.11.732a9 9 0 0 1-6.085-.711l-.108-.054a9 9 0 0 0-6.208-.682L3 4.5M3 15V4.5" />
    </svg>}
    {onHoverReport && 
            <>
            
            <div className='absolute text-gray-900 shadow-md border bg-yellow-100 w-max rounded font-medium border border-yellow-200 top-8 right-0 p-2'>
                <div>Report this case</div>
                <div className="border-[10px] border-t-0 border-t-transparent border-l-transparent border-r-transparent border-b-yellow-100 h-0 w-0 absolute -top-2 right-0"></div> 
              </div></>}
              {showReportDropDown &&
            <div className='text-xs p-1 flex flex-col shadow-md border-2 absolute  w-max right-0 top-6 bg-gray-100'>
                <div  onClick={() => {setReason("I think this case may be spam");setShowReportConfirmModal(true)}} className='p-1 hover:bg-gray-400 hover:text-white cursor-pointer'>- I think this case may be spam</div>
                <div  onClick={() => {setReason("This person is trying to sell me something");setShowReportConfirmModal(true)}} className='p-1 hover:bg-gray-400 hover:text-white cursor-pointer'>- This person is trying to sell me something</div>
                <div  onClick={() => {setReason("I think this may be a bot/robot");setShowReportConfirmModal(true)}} className='p-1 hover:bg-gray-400 hover:text-white cursor-pointer'>- I think this may be a bot/robot</div>
            </div>
            }
    </div>
    
    </div>

    </>
  )
}

export default IconsOnListView